import { isSelfHosted } from "@/helpers/self-hosted.helper"
import {
  DeployCommand,
  type CommonDeployCommandProps
} from "@/pages/DeploymentsPage/components/molecules/DeployCommand"
import { DeploymentKeyButton } from "@/pages/DeploymentsPage/components/molecules/DeploymentKeyButton"
import { InlineField } from "@/pages/DeploymentsPage/components/molecules/InlineField"
import { REGISTRY_FILENAME } from "@/pages/DeploymentsPage/const"
import { getDefaultValues, getDeployCommand, getLines } from "./helpers"

export const CommonDeployCommand = (props: CommonDeployCommandProps) => {
  const { hasDeploymentFile = true, version, ...restProps } = props
  const lines = getLines(props)

  return (
    <DeployCommand
      getDefaultValues={getDefaultValues}
      getDeployCommand={(values, defaultValues, deployProps) =>
        getDeployCommand(values, defaultValues, deployProps)
      }
      pullSecretName={REGISTRY_FILENAME}
      namespace="kodem"
      version={version}
      hasDeploymentFile={hasDeploymentFile}
      {...restProps}
    >
      {({ onError, ...rest }) => {
        return (
          <>
            <InlineField
              noNullCharacter
              line={lines["kubectl_create_namespace"]}
              {...rest}
            />
            <InlineField
              noNullCharacter
              line={lines["apply_namespace"]}
              {...rest}
            />
            <InlineField line={lines["helm_upgrade"]} {...rest} />
            <InlineField line={lines["namespace"]} {...rest} />
            <InlineField line={lines["environment"]} {...rest} />
            <InlineField
              line={lines["deploymentKey"]}
              buttons={<DeploymentKeyButton onError={onError} />}
              {...rest}
            />
            <InlineField line={lines["pullSecretName"]} {...rest} />
            {isSelfHosted() && (
              <InlineField line={lines["kontigoUrl"]} {...rest} />
            )}
            {props.autopilot && (
              <InlineField line={lines["autopilot"]} {...rest} />
            )}
            <InlineField
              noNullCharacter
              line={lines["create_namespace"]}
              {...rest}
            />
          </>
        )
      }}
    </DeployCommand>
  )
}
